module.exports = __webpack_public_path__ + "assets/media/navigations-desktop-app-store.f6711ccb.svg";